<div class="tk-grid text-white">

  <div class="flex justify-end">
    <div *ngIf="!surveySent" class="tk-i-close-white w-4 h-4 cursor-pointer" (click)="onClose()"></div>
  </div>

  <div class="row-span-2 flex flex-col items-start justify-center mx-auto">

    <ng-container *ngIf="!surveySent">
      <div class="text-xl font-semibold">{{'survey.rate-app' | translate}}</div>

      <div class="mt-1 text-xs">{{'survey.opinion-info' | translate}}</div>

      <surveym-rating class="mt-5" (ratingChanged)="onRatingChanged($event)"></surveym-rating>

      <surveym-reasons-list *ngIf="isLowRatingReasonsVisible"
                        (selectedReasonsChanged)="onSelectedReasonsChanged($event)"></surveym-reasons-list>

      <ng-container *ngIf="isRatingSelected">
        <div class="mt-4 mb-3 w-full bg-white rounded-lg text-black">
            <textarea class="w-full rounded-lg box-border p-3" rows="5" [(ngModel)]="review"
                      placeholder="{{reviewPlaceholder}}"></textarea>
        </div>

        <app-button [isLoading]="isLoading" [isActive]="true" innerTextClasses="mx-12" spinnerClasses="mx-14 my-2"
                    label="{{'labels.send' | translate | titlecase}}" (click)="onSend()"></app-button>
      </ng-container>

    </ng-container>

    <surveym-survey-sent *ngIf="surveySent" (onClose)="onCloseAfterSent()"></surveym-survey-sent>

  </div>

</div>
